module.exports = __webpack_public_path__ + "assets/img/profile-about.275e5182.svg";